import { z } from "zod";

export const STATUS_MODULO = ["ATIVO", "EXPIRADO", "DEMO", "DEMO_EXPIRADO", "FREE"];

export const STATUS_COBRADO = ["ATIVO", "EXPIRADO"];

export const schema = z.object({
	id_empresa_itens: z.number().default(0),
	id_produto: z.number({ invalid_type_error: "Selecione o produto" }).min(1, "Selecione o produto"),
	status: z.enum(STATUS_MODULO, { errorMap: () => ({ message: "Selecione o status" }) }),
	data_expiracao: z.string().min(10, "Informe a data de expiração"),
	desconto: z.coerce.number().min(0, "Não pode ser negativo").max(100, "Máximo 100%"),
	acrescimo: z.coerce.number().min(0, "Não pode ser negativo"),
	obs: z.string().max(100, "Máximo 100 caracteres").optional().nullable(),
	autorizado: z.boolean().default(false),
});

export const defaultValues = {
	id_empresa_itens: 0,
	id_produto: 0,
	status: "FREE",
	data_expiracao: "",
	desconto: 0,
	acrescimo: 0,
	obs: "",
	autorizado: false,
};
